import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import { InternalPage } from "components/InternalPage"
import { RelatedTeasers } from "../components/RelatedTeasers"
import { Stats } from "../components/Stats"

const IndexPage = ({ pageContext }) => {
  const {
    title,
    excerpt,
    content,
    featuredImage,
    TeasersBlock,
    legAncestors,
    previewSQ,
    seo,
    statsModule,
    depth,
  } = pageContext

  const teasersData = TeasersBlock?.teasersBlock
  const landing = TeasersBlock?.teasersBlock?.displayLanding

  return (
    <Layout
      ancestors={legAncestors}
      internal
      headerTitle={title}
      headerImg={featuredImage}
      preview={previewSQ}
      landing={landing}
      depth={depth}
    >
      <SEO
        title={seo.title}
        description={seo.metaDesc}
        image={featuredImage?.sourceUrl}
      />
      <InternalPage
        content={content}
        landing={landing}
        title={title}
        excerpt={excerpt}
      />
      {teasersData?.teaserblockitems?.length ? (
        <RelatedTeasers content={content} data={teasersData} />
      ) : null}

      {statsModule && <Stats landing data={statsModule} />}
    </Layout>
  )
}

export default IndexPage
